<template>
  <v-row>
    <v-col>
      <v-snackbar
          :key="index"
          v-model="show"
          right
          top
          multi-line
          :timeout="timeout"
          vertical
          :light="$vuetify.theme.dark"
          :dark="!$vuetify.theme.dark">
        <v-row>
          <v-col cols="12" class="my-2">
            <v-data-table
                :headers="headers"
                :items="order.premiums || []"
                :items-per-page="-1"
                item-key="positionId"
                disable-sort-by
                dense
                hide-default-footer
                :locale="systemLocale"
                :dark="$vuetify.theme.dark">
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.positionDescription="{ item }">
                <span :title="item.positionDescription">
                  {{ item.positionDescription && item.positionDescription.length > 20
                    ? `${item.positionDescription.substring(0,20)}...`
                    : item.positionDescription }}
                </span>
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.premium="{ item }">
                {{ item.premium }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center" my-2>
            <v-btn
                text
                color="red"
                @click="close">
              {{ $t('Закрыть') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-snackbar>
    </v-col>
  </v-row>
</template>

<script>

  export default {
    components: {
    },
    props: {
      index: {
        type: [Number, String],
        required: true
      },
      order: {
        type: Object,
        required: true
      },
      timeout: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        show: true
      }
    },
    computed: {
      headers () {
        return [
          { text: this.$t('Наименование позиции'), sortable: false, value: 'positionDescription' },
          { text: this.$t('Премия/дисконт'), sortable: false, value: 'premium' }
        ]
      }
    },
    watch: {
      timeout (value) {
        if (!value || value === 0) {
          this.hide()
        }
      },
      show (value) {
        if (!value) {
          this.hide()
        }
      }
    },
    methods: {
      close: function () {
        this.$emit('close', this.index)
      },
      hide: function () {
        this.$emit('close', 0)
      }
    }
  }
</script>
